import { useState } from 'react'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import Spinner from 'react-bootstrap/Spinner'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/AuthContext'
import { useCurrencies } from '../../hooks/useCurrencies'
import { useGroups, useInvalidateGroups } from '../../hooks/useGroups'
import { exponentOf, formatMoney } from '../../utils/money'
import { GroupFormModal } from './GroupFormModal'

export function GroupsPage() {
    const { user } = useAuth()
    const navigate = useNavigate()
    const invalidate = useInvalidateGroups()
    const [showForm, setShowForm] = useState(false)

    const { data: groups, isLoading } = useGroups()
    const { data: currencies } = useCurrencies()

    return (
        <>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h1 className="h4 mb-0">Skupiny</h1>
                {user?.isAdmin && (
                    <Button className="su-tappable" onClick={() => setShowForm(true)}>
                        <i className="bi bi-plus-lg me-1" aria-hidden="true" />
                        Nová
                    </Button>
                )}
            </div>

            {isLoading && <Spinner animation="border" />}

            {groups && groups.length === 0 && (
                <Card body className="text-secondary">
                    {user?.isAdmin
                        ? 'Zatím tu není žádná skupina. Založte první tlačítkem „Nová".'
                        : 'Zatím nejste v žádné skupině. Požádejte správce, aby vás do některé přidal.'}
                </Card>
            )}

            {groups && groups.length > 0 && (
                <Card>
                    <ListGroup variant="flush">
                        {groups.map((group) => (
                            <ListGroup.Item
                                key={group.id}
                                action
                                as={Link}
                                to={`/skupiny/${group.id}`}
                                className="d-flex align-items-center gap-2 su-tappable"
                            >
                                <div className="flex-grow-1 min-w-0">
                                    <div className="fw-semibold text-truncate">{group.name}</div>
                                    <div className="small text-secondary">
                                        {group.memberCount} {pocetClenu(group.memberCount)} · {group.currencyCodes.join(', ')}
                                    </div>
                                </div>
                                {group.myBalance !== null && group.myBalance !== undefined && (
                                    <span
                                        className={`fw-semibold text-nowrap ${
                                            group.myBalance === 0 ? 'text-secondary' : group.myBalance > 0 ? 'text-success' : 'text-danger'
                                        }`}
                                    >
                                        {formatMoney(group.myBalance, group.baseCurrencyCode, exponentOf(currencies, group.baseCurrencyCode))}
                                    </span>
                                )}
                                {group.archived && <Badge bg="secondary">Archiv</Badge>}
                                <i className="bi bi-chevron-right text-secondary" aria-hidden="true" />
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Card>
            )}

            {showForm && (
                <GroupFormModal
                    show={showForm}
                    onClose={() => setShowForm(false)}
                    onSaved={async (groupId) => {
                        await invalidate()
                        navigate(`/skupiny/${groupId}`)
                    }}
                />
            )}
        </>
    )
}

function pocetClenu(count: number): string {
    if (count === 1) {
        return 'člen'
    }
    if (count >= 2 && count <= 4) {
        return 'členové'
    }
    return 'členů'
}
